import { render } from "./InstanceTenants.vue?vue&type=template&id=ca8c9c2a&scoped=true"
import script from "./InstanceTenants.vue?vue&type=script&lang=js"
export * from "./InstanceTenants.vue?vue&type=script&lang=js"

import "./InstanceTenants.vue?vue&type=style&index=0&id=ca8c9c2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca8c9c2a"]])

export default __exports__